import React, { useCallback, useEffect, useState } from 'react';
import { sessionHealthService, SessionHealthView } from '../../services/planOfRecordService';

const POLL_MS = 30_000;

interface Props {
  sessionId: string;
}

/** The platform's session health line (agentic core R1a, WS7 goal F8), refreshed after every drain. */
const HealthLinePanel: React.FC<Props> = ({ sessionId }) => {
  const [health, setHealth] = useState<SessionHealthView | null>(null);

  const load = useCallback(async () => {
    try {
      setHealth(await sessionHealthService.get(sessionId));
    } catch {
      /* hidden until a line loads */
    }
  }, [sessionId]);

  useEffect(() => {
    load();
    const timer = setInterval(load, POLL_MS);
    return () => clearInterval(timer);
  }, [load]);

  if (!health?.line) return null;

  return (
    <div className="flex items-center gap-2 rounded-xl border border-[#e2e8f0] bg-white px-3 py-2 text-left" data-testid="health-line">
      <span className="text-[11px] font-bold text-primary tracking-widest uppercase shrink-0">Health</span>
      <span className="flex-1 min-w-0 truncate text-xs text-navy" title={health.line}>{health.line}</span>
      {health.shadow && <span className="text-[10px] font-semibold text-slate-400 uppercase shrink-0">Shadow</span>}
    </div>
  );
};

export default HealthLinePanel;
